export const routes = {
  home: {
    path: '/',
    project: {
      path: '/:projectNo',
    },
  },
  userProfile: {
    path: '/user-profile',
  },
  dashboard: {
    path: '/dashboard',
  },
  projectList: {
    path: '/project',
  },
  t1: {
    path: '/:projectNo/master-schedule',
    create: { path: '/:projectNo/master-schedule/create' },
    view: {
      path: '/:projectNo/master-schedule/:id',
    },
    manageHeaderTags: { path: '/:projectNo/master-schedule/header-tags' },
    batchAdd: { path: '/:projectNo/master-schedule/batch-add' },
  },
  t2: {
    path: '/:projectNo/design-brief',
    create: { path: '/:projectNo/design-brief/create' },
    view: { path: '/:projectNo/design-brief/:id' },
  },
  t3: {
    path: '/:projectNo/design-modification',
    create: { path: '/:projectNo/design-modification/create' },
    view: {
      path: '/:projectNo/design-modification/:id',
    },
  },
  t4: {
    path: '/:projectNo/permit-to-load',
    create: { path: '/:projectNo/permit-to-load/create' },
    view: { path: '/:projectNo/permit-to-load/:id' },
  },
  transmittals: {
    path: '/:projectNo/transmittals',
    list: {
      path: '/:projectNo/transmittals/list',
    },
    designerTransmittal: {
      path: '/:projectNo/transmittals/designer-transmittal',
      item: {
        path: '/:projectNo/transmittals/designer-transmittal/:id',
      },
      bulkUpload: {
        path: '/:projectNo/transmittals/designer-transmittal/:id/bulkUpload',
      },
      history: {
        path: '/:projectNo/transmittals/designer-transmittal/:id/history/:masterScheduleId',
      },
    },
    siteTransmittal: {
      path: '/:projectNo/transmittals/site-transmittal',
      item: {
        path: '/:projectNo/transmittals/site-transmittal/:id',
      },
      bulkUpload: {
        path: '/:projectNo/transmittals/site-transmittal/:id/bulkUpload',
      },
      history: {
        path: '/:projectNo/transmittals/site-transmittal/:id/history/:masterScheduleId',
      },
    },
    checkerTransmittal: {
      path: '/:projectNo/transmittals/checker-transmittal',
      item: {
        path: '/:projectNo/transmittals/checker-transmittal/:id',
      },
      bulkUpload: {
        path: '/:projectNo/transmittals/checker-transmittal/:id/bulkUpload',
      },
      history: {
        path: '/:projectNo/transmittals/checker-transmittal/:id/history/:masterScheduleId',
      },
    },
    lirTransmittal: {
      path: '/:projectNo/transmittals/lir-transmittal',
      item: {
        path: '/:projectNo/transmittals/lir-transmittal/:id',
      },
      bulkUpload: {
        path: '/:projectNo/transmittals/lir-transmittal/:id/bulkUpload',
      },
      history: {
        path: '/:projectNo/transmittals/lir-transmittal/:id/history/:masterScheduleId',
      },
    },
    item: {
      path: '/:projectNo/transmittals/:id',
      history: {
        path: '/:projectNo/transmittals/:id/history/:masterScheduleId',
      },
    },
  },
  projectRequest: {
    path: '/project-request',
    view: { path: '/project-request/:id' },
    create: { path: '/project-request/create' },
  },
  projectInfo: {
    view: { path: '/:projectNo/project-info/:id' },
  },
  maintenance: {
    path: '/maintenance',
  },
  users: {
    path: '/:projectNo/users',
    twcRequest: {
      list: {
        path: '/:projectNo/users/twc-request',
      },
      create: {
        path: '/:projectNo/users/twc-request/create',
      },
      detail: {
        path: '/:projectNo/users/twc-request/:id',
      },
    },
    geRequest: {
      list: {
        path: '/:projectNo/users/ge-request',
      },
      create: {
        path: '/:projectNo/users/ge-request/create',
      },
      detail: {
        path: '/:projectNo/users/ge-request/:id',
      },
    },
  },
  documentRegister: {
    path: '/:projectNo/documentRegister',
  },
  announcement: {
    list: { path: '/announcement' },
  },
  myGems: {
    path: '/myGems',
  },
  common: {
    noProjectAccessRight: {
      path: '/no-project-access-right',
    },
    noAccessRight: {
      path: '/no-access-right',
    },
    requireLogin: {
      path: '/require-login',
    },
    pageNotFound: {
      path: '/page-not-found',
    },
    accountLocked: {
      path: '/account-locked',
    },
  },
  admin: {
    main: {
      path: '/admin',
    },
    item: {
      path: '/admin/:type',
    },
  },
  report: {
    main: { path: '/report' },
    checklistStat: { path: '/report/checklist-stat' },
    mobileUsage: { path: '/report/mobile-usage' },
  },
};
